import { render, staticRenderFns } from "./W2S.vue?vue&type=template&id=45d205ac"
import script from "./W2S.vue?vue&type=script&lang=js"
export * from "./W2S.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports